import { RouteObject } from 'react-router-dom';
import { GroupJournalTopicAddPage, GroupJournalTopicEditPage } from 'pages';
import { appPaths } from 'consts/paths/paths';
import { AppActions } from 'types';
import { PERMISSIONS_NAME } from 'consts/permissions/permissions';
import { AbilityRoute } from 'navigation/AbilityRoute/AbilityRoute';
import { JournalNavigate } from '../../components';

export const journalTopicRoutes: RouteObject[] = [
    {
        path: appPaths.app.journals.groupJournalDetails.pickedJournal.topics.add,
        element: (
            <AbilityRoute
                can={{
                    action: AppActions.EDIT_AND_ADD,
                    subject: PERMISSIONS_NAME.GROUP_JOURNALS_TOPICS,
                }}
            >
                <GroupJournalTopicAddPage />
            </AbilityRoute>
        ),
    },
    {
        path: appPaths.app.journals.groupJournalDetails.pickedJournal.topics.edit.base,
        element: (
            <JournalNavigate
                to={appPaths.app.journals.groupJournalDetails.pickedJournal.topics.base}
            />
        ),
    },
    {
        path: appPaths.app.journals.groupJournalDetails.pickedJournal.topics.edit.pickedTopic,
        element: (
            <AbilityRoute
                can={{
                    action: AppActions.EDIT_AND_ADD,
                    subject: PERMISSIONS_NAME.GROUP_JOURNALS_TOPICS,
                }}
            >
                <GroupJournalTopicEditPage />
            </AbilityRoute>
        ),
    },
];
